const handleUpdateTitleAction = function(view, action) {
  view.$(`#steptab-${action.stepIndex} .step-title__text`).empty().append(action.template); // for horizontal layout
  view.$(`#steptab-${action.stepIndex} .section-header__title-text`).empty().append(action.template); // for verticle layout
};

const handleUpdateSubtitleAction = function(view, action) {
  return view.setSubtitleTemplate(action.template, action.stepIndex);
};

const store =  {
  UPDATE_TITLE_TEMPLATE: handleUpdateTitleAction,
  UPDATE_SUBTITLE_TEMPLATE: handleUpdateSubtitleAction,
};

export default store;
